import { Capacitor } from "@capacitor/core";
import { PLATFORM_TARGET } from "@/config/env";

/**
 * Where the bundle is running. `steam` is a build-time target (VITE_PLATFORM=steam) because the
 * desktop wrapper serves the same web bundle; iOS/Android come from Capacitor at runtime.
 */
export type PlatformName = "web" | "ios" | "android" | "steam";

function detect(): PlatformName {
  if (PLATFORM_TARGET === "steam") return "steam";
  const cap = Capacitor.getPlatform();
  return cap === "ios" || cap === "android" ? cap : "web";
}

export const platform: PlatformName = detect();
export const isNative: boolean = Capacitor.isNativePlatform();
/** @public True for the two app-store targets: where store billing, ads SDKs and ATT exist. */
export const isMobileStore: boolean = platform === "ios" || platform === "android";
